import { render } from "./MyRebatesHistory.vue?vue&type=template&id=73bd0640"
import script from "./MyRebatesHistory.vue?vue&type=script&lang=ts"
export * from "./MyRebatesHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script